/**
 * useFiltersConfig
 */
import { useMemo } from 'react';

import useMediaConfig from 'bdvp-common/src/hooks/config/useMediaConfig';
import { MEDIA_CONFIG_CONTEXT } from 'bdvp-common/src/utils/constants';
import { useAdobeTarget } from 'bdvp-common/src/hooks/store';

/** For dev purposes, to be removed */
import filterGroups_B from './filterGroups_B.json';
import { useLocation } from 'react-router-dom';
/** end */

const useFiltersConfig = () => {

    const config = useMediaConfig(MEDIA_CONFIG_CONTEXT.search);

    /** For dev purposes, to be removed */
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.get('fg') === 'B') {

        config.filterGroups = filterGroups_B;

    }
    /** end */

    const {
        payload: filterGroups,
        loading: isTargetOfferLoading,
        enabled: testEnabled,
    } = useAdobeTarget(config.adobeTarget, 'filterGroups');

    const loading = testEnabled && isTargetOfferLoading;

    const {
        filtersConfig,
        fieldsIds,
        fieldsConfig,
    } = useMemo(() => {

        if (loading) {

            return {
                filtersConfig: [],
                fieldsIds: {
                    withValues: [],
                    withoutValues: [],
                },
                fieldsConfig: [],
            };

        }

        const filtersConfig = filterGroups ? filterGroups : config?.filterGroups ?? [];
        const additionalFiltersConfig = config?.additionalFilters ?? [];

        const flatFiltersConfig = filtersConfig.reduce(
            (arr, elem) => [
                ...arr,
                ...elem.filters,
            ],
            []
        );

        const fieldsConfig = [
            ...flatFiltersConfig,
            ...additionalFiltersConfig,
        ].reduce(
            (arr, elem) => [
                ...arr,
                ...elem.fields,
            ],
            []
        );

        const fieldsIds = fieldsConfig.reduce((acc, { id, skipValues = false }) => {

            acc[skipValues ? 'withoutValues' : 'withValues'].push(id);

            return acc;

        }, {
            withValues: [],
            withoutValues: [],
        });

        return {
            filtersConfig,
            fieldsIds,
            fieldsConfig,
        };

    }, [
        config,
        filterGroups,
        loading,
    ]);

    return {
        filtersConfig,
        fieldsIds,
        fieldsConfig,
        loading,
    };

};

export default useFiltersConfig;
